module.exports = __webpack_public_path__ + "static/media/TripWire.ff4f5762.jpg";